module.exports = __webpack_public_path__ + "static/media/ipo_campaign_bannar.f27fa767.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ipo_campaign_bannar.png
// module id = 517
// module chunks = 0